import { render, staticRenderFns } from "./InspectionListCard.vue?vue&type=template&id=b722645c&scoped=true&"
import script from "./InspectionListCard.vue?vue&type=script&lang=js&"
export * from "./InspectionListCard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionListCard.vue?vue&type=style&index=0&id=b722645c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b722645c",
  null
  
)

export default component.exports